import { createContext, useContext, type ReactNode } from 'react';
import { HoldDragRanking } from './HoldDragRanking.js';
import type { RankingInteractionComponent } from './types.js';

/** Change this one binding to replace the interaction everywhere. */
export const DEFAULT_RANKING_INTERACTION: RankingInteractionComponent = HoldDragRanking;

const RankingInteractionContext = createContext<RankingInteractionComponent>(
  DEFAULT_RANKING_INTERACTION,
);

export function RankingInteractionProvider({
  value,
  children,
}: {
  value: RankingInteractionComponent;
  children: ReactNode;
}) {
  return (
    <RankingInteractionContext.Provider value={value}>
      {children}
    </RankingInteractionContext.Provider>
  );
}

/** The ranking interaction currently in force. */
export function useRankingInteraction(): RankingInteractionComponent {
  return useContext(RankingInteractionContext);
}
